import React, { useState } from 'react';
import './ModalUpload.css';

const ModalUpload = ({ isOpen, onClose, onUpload, access, cancelUpload }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");

  // Lista de extensões bloqueadas
  const blockedExtensions = [
    ".exe", ".bat", ".cmd", ".sh", ".js", ".vbs", ".scr",
    ".msi", ".pif", ".jar", ".wsf", ".com", ".cpl"
  ];

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const extension = file ? file.name.split('.').pop() : "";

    if (blockedExtensions.includes(`.${extension.toLowerCase()}`) && access !== "0") {
      setError("Este tipo de arquivo não é permitido.");
      setSelectedFile(null);
    } else {
      setError("");
      setSelectedFile(file);
    }
  };

  

  const handleUpload = () => {
    if (selectedFile) {
      onUpload(selectedFile);
      onClose();
    } else {
      setError("Nenhum arquivo selecionado.");
    }
  };

  const close = () => {
    cancelUpload()
    onClose()
    setError('')
  }

  return (
    isOpen && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3>Upload de Arquivo</h3>
          <input type="file" onChange={handleFileChange} />
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button onClick={handleUpload}>Upload</button>
            <button style={{backgroundColor: "#ddd", color: "#333"}} onClick={close} >Cancelar</button>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalUpload;
